import { Stack, Text } from "@mantine/core";
import { type ReactNode, memo } from "react";
import { MdSearch } from "react-icons/md";
import { selectSearch } from "src/reducks/SearchStore";
import { useAppSelector } from "src/store/hooks";

export const SearchLayout = ({
  children,
  text,
}: {
  children: ReactNode;
  text: string;
}) => {
  const searchState = useAppSelector(selectSearch);

  return (
    <>
      {searchState.toggleSearch ? (
        <>
          {searchState.search.length === 0 ? (
            <main>
              <Stack spacing={24} align="center" mt={113}>
                <MdSearch size={48} color="#969696" />
                <Text color="#969696">{text}</Text>
              </Stack>
            </main>
          ) : (
            children
          )}
        </>
      ) : (
        children
      )}
    </>
  );
};

export const SearchLayoutMemo = memo(SearchLayout);
